module.exports = __webpack_public_path__ + "static/media/3.910e669c.png";